export default function (s, e) {
  const t = {}
  // eslint-disable-next-line
  for (const p2 in s) {
    if (Object.prototype.hasOwnProperty.call(s, p2) && e.indexOf(p2) < 0) {
      t[p2] = s[p2]
    }
  }

  if (s != null && typeof Object.getOwnPropertySymbols === 'function') {
    for (let i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (
        e.indexOf(p[i]) < 0 &&
        Object.prototype.propertyIsEnumerable.call(s, p[i])
      ) {
        t[p[i]] = s[p[i]]
      }
    }
  }
  return t
}
